import { FontIcon } from "@fluentui/react";
import { Dropdown } from "antd";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { openQuickUploadTranslationDocument, openUploadTranslationDocument } from "../../../../redux/EngageTranslation/EngageTranslationAction";
import "./UploadButton.css";

const UploadButton = (props: any) => {
  const dispatch = useAppDispatch();

  // const onClick = (e: any) => {
  //   if (e.key == 1) {
  //     dispatch(openUploadTranslationDocument());
  //   }
  //   if (e.key == 2) {
  //     dispatch(openQuickUploadTranslationDocument());
  //   }
  // };

  // const items = [
  //   {
  //     key: "1",
  //     label: "Upload",
  //   },
  //   {
  //     key: "2",
  //     label: "Quick Upload",
  //   },
  // ];

  return (
    <button
      className="upload-btn"
      onClick={() => dispatch(openUploadTranslationDocument())}>
      Upload
      {/* <FontIcon
        className="upload-btn-icon"
        iconName="Upload"
      /> */}
      {/* <div className="upload-btn-secondary-section">
          <FontIcon
            className="upload-btn-chevron-icon"
            style={{ marginTop: "3px" }}
            iconName="StatusTriangle"
          />
        </div> */}
    </button>
  );
};

export default UploadButton;
